<template>
  <div style="width: 100%; height: 100%">
    <Blacklist v-if="blPageIndex === 1" />
    <ChatHistory v-if="blPageIndex === 2" />
  </div>
</template>

<script>
import Blacklist from './Blacklist'
import ChatHistory from './ChatHistory'
export default {
  name: '',
  data() {
    return {
    }
  },
  props: [],
  components: {
    Blacklist,
    ChatHistory
  },
  computed: {
    blPageIndex() {
      return this.$store.state.user.blPageIndex
    }
  },
  beforeDestroy() {
    this.$store.commit('user/setBlPageIndex', { blPageIndex: 1 })
  },
  mounted() {},
  methods: {}
}
</script>
